<template>
    <div class="mr-1" style="padding-top: 0px !important">
        <!-- <div class="breadcrumbnewtheme pb-3">
            <div class="pre gap-0p5 fw-500">
                Tickets
            </div>
            <span style="color:#b2bec3">/</span>
            <div class="pre gap-0p5 fw-500 text-capitalize">
                {{ $route.query.hasOwnProperty("view_ticket") ? $route.query.view_ticket : 'Overall' }}
            </div>
            <span style="color:#b2bec3">/</span>
            <span class="curr gap-0p5 fw-500">
                List View
            </span>
        </div> -->
        <div class="page-layout">
            <div class="pb-5 pt-5 d-flex align-items-center" v-if="list && list.length">
                <div class="d-flex align-items-center mr-2">
                    <div v-if="$route.path != '/ticketdetails'" @click="gotoManageTicket()">
                        <el-tooltip class="item pull-left" effect="dark" content="Click to Go Back" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/previous.svg" class="mr-2">
                        </el-tooltip>
                    </div>
                    <router-link v-if="!$route.path.startsWith('/ticketdetails')" :to="{ path: $routerHistory.next().path }">
                        <el-tooltip class="item pull-left" effect="dark" content="Click to Go Forward"
                            placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/next.svg">
                        </el-tooltip>
                    </router-link>
                </div>
                <el-tooltip class="item" effect="dark" content="Manage Tickets" placement="top">
                    <div class="manage mr-2 pointer" @click="gotoManageTicket()" v-if="list && list.length">
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/manage_ticket.svg" alt="">
                    </div>
                </el-tooltip>
                <div class="divide_line" v-if="list && list.length"></div>
                <div class="d-flex align-items-center">
                    <ul class="ticket_list mb-0">
                        <li class="ticket_list_number" :class="{'ticket_list_number-selected':selected == index_1}" v-show="index_1<=6" v-for="(item,index_1) in list" :key="index_1+''+item.ticket_id">
                            <span class="pointer" @click="select_tab(index_1, item)">{{item.name}}</span>
                            <span class="ml-2" @click="remove_tab(index_1)">
                                <i class="icon icon-close fs-14"></i>
                            </span>
                        </li>
                        <li class="dropdown" v-if="list.length>7">
                            <button class="dropbtn">
                                <i class="icon-chevron-down" style="position:relative;top:3px"></i>
                            </button>
                            <div class="dropdown-content">
                                <a data-toggle="tab" :class="{'ticket_list_number-selected':selected == index_2+7}" v-for="(item,index_2) in list.slice(7,list.length)" :key="index_2+''+item.ticket_id" class="nav-link tabbed pointer d-flex align-items-center justify-content-between" @click="selected_ticket_id=item.ticket_id" style="padding: 12px 6px;width: 100%;border-radius: 5px !important;">
                                    <span v-on:click="select_tab(index_2+7, item)" class="li_span text-nowrap mr-2 pointer">
                                        {{item.name}}
                                    </span>
                                    <!-- <span class="close_tab pointer" v-on:click="remove_tab(index_2+7,$event);"> -->
                                        <el-tooltip class="item" effect="dark" content="Close" placement="top">
                                            <i class="icon-close-circle-outline pointer no-border" style="margin-right: 0px!important;" v-on:click="remove_tab(index_2+7);"></i>
                                        </el-tooltip>
                                    <!-- </span> -->
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <ticket-list-view v-show="selected_name =='manage-ticket'"></ticket-list-view>
            <!-- <div class="" v-for="(item,index_3) in list" :key="index_3+''+item.ticket_id"> -->
                <!-- <ticket-details v-show="selected_name=='ticket-details'" :ticket_id="$route.params.id"></ticket-details> -->
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { EventBus } from '../eventBus/nav-bar-event'
const TicketListView = () => import("./TicketListView.vue");
const TicketDetails = () => import("./TicketDetails.vue")
export default {
    data(){
        return{
            list: [],
            selected: "",
            selected_name: "manage-ticket",
            totalTickets: 0,
            selected_ticket_id: "",
            triggerZinde:false
        }
    },
    components:{
        TicketListView,
        TicketDetails
    },
    methods:{
        addTicket(ticket) {
            var ticket_id = ticket.ticket_id;
            var ticket_number = ticket.ticket_number;
            var is_parent_ticket = ticket.is_parent_ticket || false
            var subject =  ticket.subject || ''
            var is_present = false;
            var approval = ticket.approval || false
            var obj = {};
            this.list.forEach(function(tab) {
                if (tab.ticket_id == ticket_id) {
                    is_present = true;
                    obj = tab;
                    return;
                }
            });
            if (is_present) {
                this.selected = this.list.indexOf(obj);
                this.selected_name = obj.value;
            } else {
                if (this.list.length >= 7) {
                    this.list.splice(this.list.length, 0, {
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject,
                        approval:approval
                    });
                } else {
                    this.list.push({
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject,
                        approval:approval
                    });
                }
                this.selected_name = "ticket-details";
                if(String(this.$route.path).startsWith('/pm')) {
                    this.$router.push({ path: "/pm/ticketdetails/" + ticket_id });
                }
                else {
                    if(this.$route.query.hasOwnProperty('from_filtered_status') && this.$route.query.hasOwnProperty('type')){
                        this.$router.push({ 
                            path: "/ticketdetails/" + ticket_id,
                            query: this.$route.query 
                        });
                    } else {
                        this.$router.push({ path: "/ticketdetails/" + ticket_id });
                    }
                }
                this.totalTickets++;
                this.selected = this.list.length - 1;
            }
        },
        select_tab(item, obj){
            var prev = this.selected;
            this.selected = item;
            this.selected_ticket_id = obj.ticket_id;
            if (item >= 7) {
                this.selected = prev;
                var x = this.list[prev];
                this.list[prev] = obj;
                this.list[item] = x;
            }
            this.selected_name = obj.value;
            if (obj.value == "ticket-details") {
                this.$router.push({ path: "/ticketdetails/" + obj.ticket_id }).catch(()=>{});
                EventBus.$emit('ReloadDetailsDataById',obj.ticket_id)
            } else if (obj.value == "manage-ticket") {
                if(this.$route.query.view_ticket) {
                    this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                } else {
                    this.$router.push({ path: "/ticketdetails/" }).catch(()=>{});
                }
            }
            let temp_data = {
                list: this.list,
                selected: this.selected,
            }
            localStorage.setItem('newListData', JSON.stringify(temp_data))
        },
        remove_tab(index){
            this.totalTickets = this.totalTickets - 1;
            // e.stopImmediatePropagation();
            Vue.delete(this.list, index);
            if (this.selected == index) {
                this.selected = index - 1;
            } else if (this.selected > index) {
                this.selected = this.selected - 1;
            }
            if(this.selected < 0) this.selected = 0
            if(this.list && this.list.length){
                this.selected_name = this.list[this.selected].value;
            }
            if (this.selected_name == "ticket-details") {
                let statusTab = []
                EventBus.$emit('updateTableViewTab',statusTab)
                if(this.list && this.list.length){
                    if(String(this.$route.path).startsWith('/pm')) {
                        this.$router.push({
                            path: "/pm/ticketdetails/" + this.list[this.selected].ticket_id
                        }).catch(()=>{});
                        EventBus.$emit('ReloadDetailsDataById', this.list[this.selected].ticket_id)
                    }
                    else {
                        this.$router.push({
                            path: "/ticketdetails/" + this.list[this.selected].ticket_id
                        }).catch(()=>{});
                        EventBus.$emit('ReloadDetailsDataById', this.list[this.selected].ticket_id)
                    }
                }else{
                    if(String(this.$route.path).startsWith('/pm')) {
                        this.$router.push({
                            path: "/pm/ticketdetails"
                        }).catch(()=>{});
                    }
                    else {
                        // this.$router.push({
                        //     path: "/ticketdetails/"
                        // }).catch(()=>{});
                        if(this.$route.query.view_ticket) {
                            this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                        } else {
                            this.$router.push({ path: "/ticketdetails" }).catch(()=>{});
                        }
                    }
                    this.selected_name = "manage-ticket"
                }
            } else if (this.selected_name == "manage-ticket") {
                if(String(this.$route.path).startsWith('/pm')) {
                    this.$router.push({
                        path: "/pm/ticketdetails/"
                    }).catch(()=>{});
                }
                else {
                    // this.$router.push({
                    //     path: "/ticketdetails/"
                    // }).catch(()=>{});
                    if(this.$route.query.view_ticket) {
                        this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                    } else {
                        this.$router.push({ path: "/ticketdetails" }).catch(()=>{});
                    }
                }
            }
        },
        gotoManageTicket(){
            if(String(this.$route.path).startsWith('/pm')) {
                this.$router.push({
                    path: "/pm/ticketdetails/"
                }).catch(()=>{});
            }
            else {
                // this.$router.push({
                //     path: "/ticketdetails/"
                // }).catch(()=>{});
                if(this.$route.query.view_ticket) {
                    this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                } else {
                    this.$router.push({ path: "/ticketdetails" }).catch(()=>{});
                }
            }
            if(this.selected_name == 'ticket-details'){
                let statusTab = []
                EventBus.$emit('updateTableViewTab',statusTab)
            }
            this.selected_name = "manage-ticket"
        },
        addTicketNew(ticket){
            var ticket_id = ticket.ticket_id;
            var ticket_number = ticket.ticket_number;
            var is_parent_ticket = ticket.is_parent_ticket || false
            var subject = ticket.subject || ''
            var approval = ticket.approval || false
            this.list.push({
                name: "Ticket #" + ticket_number,
                value: "ticket-details",
                ticket_id: ticket_id,
                is_parent_ticket:is_parent_ticket || false,
                subject:subject,
                approval:approval
            });
            this.selected_name = "ticket-details";
            this.$router.push({ path: "/ticketdetails/" + ticket_id });
            this.totalTickets++;
            this.selected = this.list.length - 1;
            if(this.selected < 0) this.selected = 0
        },
        addRedirectedTicket(ticket){
            var ticket_id = ticket.ticket_id;
            var ticket_number = ticket.ticket_number;
            var is_parent_ticket = ticket.is_parent_ticket || false
            var subject = ticket.subject || ''
            var approval = ticket.approval || false
            this.selected_name = "ticket-details";
            this.$router.push({ path: "/ticketdetails/" + ticket_id });
            this.totalTickets++;
            var selected_index = 0
            this.list.forEach((el, el_index) => {
                if(el.name == "Ticket #"+ticket_number){
                    selected_index = el_index
                }
            })
            this.selected = selected_index;
            if(this.selected < 0) this.selected = 0
        },
        deepLinkTicketDetails() {
            let ua = navigator.userAgent.toLowerCase();
            let isAndroid = ua.indexOf("android") > -1; // android check
            let isIphone = ua.indexOf("iphone") > -1; // ios check
            if (isIphone == true) {
                let app = { 
                    launchApp: function() {
                        setTimeout(function() {
                            window.location.href = "https://apps.apple.com/in/app/digihelp/id1546713349";
                        }, 25);
                        window.location.href = "bundlename://linkname"; //which page to open(now from mobile, check its authorization)
                    },
                    openWebApp: function() {
                        window.location.href = "https://apps.apple.com/in/app/digihelp/id1546713349";
                    }
                };
                app.launchApp();
            } else if (isAndroid== true) {
                let app = { 
                    launchApp: function() {
                        window.location.replace("bundlename://linkname"); //which page to open(now from mobile, check its authorization)
                        setTimeout(this.openWebApp, 500);
                    },
                    openWebApp: function() {
                        window.location.href =  "https://play.google.com/store/apps/details?id=com.digicollect.helpdesk";
                    }
                };
                app.launchApp();
            }else{
            //navigate to website url
                if(String(this.$route.path).startsWith('/pm')) {
                    this.$router.push({ path: "/pm/ticketdetails/" }).catch(()=>{});
                } else {
                    // this.$router.push({ path: "/ticketdetails/" }).catch(()=>{});
                    if(this.$route.query.view_ticket) {
                        this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                    } else {
                        if(this.$route.params.id) {
                            this.selected_name = "ticket-details";
                            this.$router.push({ path: "/ticketdetails/"+this.$route.params.id }).catch(()=>{});
                        } else {
                            this.$router.push({ path: "/ticketdetails" }).catch(()=>{});
                        }
                    }
                }
            }
        }
    },
    created(){
        // this.deepLinkTicketDetails();
        if(localStorage.getItem('newListData')){
            let temp_list = JSON.parse(localStorage.getItem('newListData'))
            this.list = temp_list.list
            this.selected = temp_list.selected
            // if(this.list.length > 0){
            //     this.selected_name = 'ticket-details'
            //     this.$router.push({
            //         path: "/ticketdetails/" + this.list[this.selected].ticket_id
            //     }).catch(()=>{});
            // }
        }
        // if(this.$route.query.redirected_from == 'edit_ticket'){
        //     this.list = this.$route.query.list
        //     this.addRedirectedTicket(this.$route.query.ticket)
        // }
    },
    mounted(){
        if(Object.keys(this.callTicketsViewApi).length){
            this.addTicket(this.callTicketsViewApi)
        }
        EventBus.$on('ticketSavedSuccess',ticket=>{
            this.addTicketNew(ticket)
        })
        EventBus.$on('tabactivate',ticket=>{
            this.addTicket(ticket)
        })
        EventBus.$on('updateActiveView',()=>{
            this.list = []
            this.selected_name = "manage-ticket"
            let statusTab = []
            EventBus.$emit('updateTableViewTab',statusTab)
        })
        if(this.$route.name == 'TicketsList'){
            if(this.selected_name == 'manage-ticket' && this.$route.params && this.$route.params.id != ''){
                if(String(this.$route.path).startsWith('/pm')) {
                    this.$router.push({ path: "/pm/ticketdetails/" }).catch(()=>{});
                } else {
                    // this.$router.push({ path: "/ticketdetails/" }).catch(()=>{});
                    if(this.$route.query.view_ticket) {
                        this.$router.push({ path: "/ticketdetails", query: {'view_ticket': this.$route.query.view_ticket} })
                    } else {
                        if(this.$route.params.id) {
                            this.selected_name = "ticket-details";
                            this.$router.push({ path: "/ticketdetails/"+this.$route.params.id }).catch(()=>{});
                        } else {
                            this.$router.push({ path: "/ticketdetails" }).catch(()=>{});
                        }
                    }
                }
            }
        }
    },
    computed: {
        callTicketsViewApi(){
            return this.$store.state.store.callTicketsViewApi
        }
    },
    watch: {
        'list'(newList, oldList){
            let temp_data = {
                list: newList,
                selected: this.selected,
            }
            localStorage.setItem('newListData', JSON.stringify(temp_data))
        }
    },
    destroyed(){
        this.$store.commit('setCallTicketsViewApi', {});
        EventBus.$off('tabactivate');
        EventBus.$off('tabactivateSuccess');
        EventBus.$off('updateActiveView');
    },
    // beforeDestroy(){
    //     localStorage.removeItem('newListData')
    // },
}
</script>
<style scoped>
.ticket_list{
    padding-left: 0px;
    display: inline-block;
    flex-direction: row;
}
.ticket_list_number{
    list-style: none;
    background-color: #ffffff;
    padding: 5px 10px;
    border-radius: 5px;
    max-width: 150px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
}
.ticket_list_number i{
    border:1px solid #000000;
    border-radius:50px;
    color: #000000;
}
.ticket_list_number-selected{
    background-color: #00448b !important;
    color: #fff !important;
}
.ticket_list_number-selected .li_span{
    color: #fff !important
}
.ticket_list_number-selected i{
    color: #fff !important;
    border:1px solid #fff !important;
}
.ticket_list_number-selected i.no-border{
    border: none !important;
}
.divide_line{
    border: 1px solid #00448b;
    margin-left: 10px;
    margin-right: 10px;
    height: 30px;
}
.dropbtn {
    background-color: #00448b;
    color: #fff;
    cursor: pointer;
    margin-top: -5px;
    border-radius: 5px;
    line-height: 33px;
}
.dropbtn:hover {
    background-color: #00448b;
}
.dropbtn i {
    color: #fff !important;
}
.dropdown {
    position: relative;
    display: inline-block;
}
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fff;
    /* min-width: 190px; */
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    border-radius:5px;
    z-index: 1;
    right: 0px;
    top: 32px;
}
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed {
    width: 100%;
    vertical-align: middle;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
    background-color: #eee;
}
.dropdown:hover .dropdown-content {
    display: block;
}

/* New Theme */

.gap-0p5{
    gap: 0.5rem;
}
.fs-2rem{
    font-size: 2rem;
}
.position-content-main{
    height: auto !important;
    border-radius: 25px;
    background-color: #f0ddb7;
}
</style>